import { FocusTrap, FocusTrapFactory } from '@angular/cdk/a11y';
import { AfterViewInit, ChangeDetectionStrategy, ChangeDetectorRef, Component, ElementRef, Input, OnDestroy } from '@angular/core';
import { AlertType } from '@nimbus-library/features/modal/components/confirm-modal/confirm-modal.component';
import { Modal } from '../../models/modal.model';

@Component({
  standalone: false,
  selector: 'nimbus-modal',
  templateUrl: './nimbus-modal.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class NimbusModalComponent implements AfterViewInit, OnDestroy {
  @Input()
  public alertType: AlertType;
  @Input()
  public hideFooter: boolean = false;

  private readonly focusTrap: FocusTrap;
  private timeoutHandle: number;

  public AlertType = AlertType;

  public constructor(
    private readonly el: ElementRef,
    private readonly modal: Modal,
    private readonly changeDetectorRef: ChangeDetectorRef,
    private readonly focusTrapFactory: FocusTrapFactory,
  ) {
    this.focusTrap = this.focusTrapFactory.create(this.el.nativeElement, false);
  }

  public ngAfterViewInit(): void {
    this.focusTrap.focusInitialElementWhenReady().then((hasMovedFocus) => {
      if (!hasMovedFocus) {
        this.el.nativeElement.focus();
      }
    });
  }

  public onResize(event: any) {
    clearTimeout(this.timeoutHandle);
  }

  public resizeHandler() {
    this.modal.overlayRef.updateSize({
      maxHeight: document.body.clientHeight / 1.5,
    });
    this.modal.overlayRef.updatePosition();
    this.changeDetectorRef.detectChanges();
  }

  public close() {
    this.modal.close(true);
  }

  public ngOnDestroy(): void {
    this.focusTrap.destroy();
  }
}
